<template>
  <div id="account-recovery">
    <form id="account-recovery-form" @submit.prevent="submitForm">
      <div class="row align-center">
        <div class="small-12 medium-5 columns">

          <label v-if="questions.length === 0">
            {{ 'Login name'|t }}:
            <input type="text"class="text-center" v-model="username" :placeholder="'User name'|t" required="required" autofocus />
          </label>

          <fieldset class="fieldset" v-if="questions.length > 0">
            <legend>{{ '%s account recovery questions'|t(username) }}</legend>
            <p class="help-text callout warning">{{ 'Answer all questions.'|t }}</p>
            <label v-for="(q, key) in questions" :key="key">
              <strong>{{ q.q }}?</strong>
              <input type="text" class="text-center" v-model="questions[key].a" required="required" />
            </label>
          </fieldset>

          <label v-if="questions.length > 0">
            {{ 'New password'|t }}:
            <input type="text" class="text-center" v-model="new_password" required="required" />
          </label>

          <input type="submit" name="submit" :value="'Submit'|t" class="medium expanded success button" />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import router from '@/routes'
  import api from '@/api';

  export default {
    name: 'AccountRecoveryForm',
    data() {
      return {
        username: "",
        token: "",
        new_password: "",
        questions: [],
      }
    },
    methods: {
      submitForm() {
        if (this.token.length === 0) {
          api.resetUserPasswordChallenge(
            {user_name: this.username},
            data => {
              this.token = data.token;
              for (let i in data.questions) {
                this.questions.push({q: data.questions[i], a: ""})
              }
            }
          )
        } else {
          let request = {token: this.token, new_password: this.new_password, answers: {}};
          for (let i in this.questions) {
            let a = this.questions[i];
            request.answers[a.q] = a.a
          }

          this.username = "";
          this.token = "";
          this.new_password = "";
          this.questions = [];

          api.resetUserPasswordAnswer(
            request,
            data => {
              this.$store.commit('messages/addMessage', {
                type: "status",
                message: "Password has been changed.",
              }, {root: true});
              router.push({name: 'login'});
            }
          )
        }
      }
    },
    created() {
      if (this.$store.getters['auth/isAuthed']) {
        router.push({name: 'admin'});
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/AccountRecovery.vue